// import { useEffect, useState } from 'react';
import Ontology from '../../components/Ontology';
//, { homeBlockHeight }

const OntologyView = () => {
    return <Ontology />;
};

export default OntologyView;
